module.exports = __webpack_public_path__ + "img/38.10.pH.ae5e506b.png";